module.exports = __webpack_public_path__ + "static/media/audio.08c3698f.svg";